import { React, useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./navbar/Navbar";
import ModalPreLoginTres from "./modals/ModalPreLoginTres";
import ModalBalanaces from "./modals/ModalBalances";
import Footer from "./footer/Footer";



const Main = ({M}) => {
   const [modalPreLogin, setModalPreLogin] = useState("");
   const [modalBalances, setModalBalances] = useState("");

   return (
      <>
         <Navbar M={M} setModalPreLogin={setModalPreLogin}/>
         <Outlet />
         <Footer setModalBalances={setModalBalances}/>
         <ModalPreLoginTres modalPreLogin={modalPreLogin} setModalPreLogin={setModalPreLogin}/>
         <ModalBalanaces modalBalances={modalBalances} setModalBalances={setModalBalances}/>
      </>
   );
};

export default Main;
